import { render } from "./WalletWithdrawal.vue?vue&type=template&id=47fa0b1a&scoped=true"
import script from "./WalletWithdrawal.vue?vue&type=script&lang=js"
export * from "./WalletWithdrawal.vue?vue&type=script&lang=js"

import "./WalletWithdrawal.vue?vue&type=style&index=0&id=47fa0b1a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47fa0b1a"]])

export default __exports__